import './chunk-1fafdf15.js';
import './chunk-ce068f0a.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { F as Field } from './chunk-89251f0f.js';
export { F as BField } from './chunk-89251f0f.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Field);
  }
};
use(Plugin);

export default Plugin;
